import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {AuthProvider} from "context/auth-context";
import {CartProvider} from "context/cart-context";
import * as serviceWorker from "./serviceWorker";
import {Provider} from "react-redux";
import store from "app/store";
import "react-loading-skeleton/dist/skeleton.css"
import ReactGA from "react-ga4";
import siteConfig from "./constants/site-configs";

ReactGA.initialize(siteConfig.googleAnalyticsCode || "");

ReactDOM.render(
  <Provider store={store}>
    <AuthProvider>
      <CartProvider>
        <App/>
      </CartProvider>
    </AuthProvider>
  </Provider>
  ,
  document.getElementById("root")
);

serviceWorker.register();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
